import { FC } from 'react';
import { IonRefresher, IonRefresherContent, isPlatform } from '@ionic/react';
import { AllieRefresherProps } from './Refresher.types';

export const AllieRefresher: FC<AllieRefresherProps> = ({ contentProps, onRefresh, ...props }) => {
  const spinner = contentProps?.refreshingSpinner || 'bubbles';

  return (
    !isPlatform('iphone') ?
      <IonRefresher
        slot="fixed"
        onIonRefresh={onRefresh}
        data-testid="monitoring-refresher"
        {...props}
      >
        <IonRefresherContent
          {...contentProps}
          refreshingSpinner={spinner}
        ></IonRefresherContent>
      </IonRefresher>
      : <></>
  );
};
